import config from './config'
import { callAuthenticatedApi } from './authenticated-api'

const apiUrls = {
  remote: config.passesRemoteApiUrl,
  local: config.passesLocalApiUrl
}

const apiError = (err, fallbackMessage) => err.response?.data ?? { ok: false, error: { message: fallbackMessage } }

const makePass = async ({ apiSource, apiKey, apiMode, templateId, variables }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/makePass/${templateId}`,
      method: "PUT",
      data: variables ?? {}
    }

    let result = await callApi({ apiKey, apiMode, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error making passes")
  }
}

const getIssuedPasses = async ({ apiSource, apiKey, templateId, mode, startRow, maxRows }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getIssuedPasses/${templateId}/${startRow}/${maxRows}`,
      method: "GET"
    }

    let result = await callApi({ apiKey, apiMode: mode, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting passes list")
  }
}


const getPass = async ({ apiSource, apiKey, passId }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getPass/${passId}`,
      method: "GET"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting pass")
  }
}


const patchPass = async ({ apiSource, apiKey, passId, variables }) => {
  try {
      let options = {
        url: `${apiUrls[apiSource]}/patchPass/${passId}/true`, // true = push changes to Apple devices]
        method: "PUT",
        data: {
          variables
        }
      }

      let result = await callApi({ apiKey, options })

      return result

  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error updating pass")
  }
}

const getPassNotifications = async ({ apiSource, apiKey, passId }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getPassNotifications/${passId}`,
      method: "GET"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting notifications")
  }
}

const notifyPass = async ({ apiSource, apiKey, passId, notification }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/notifyPass/${passId}`,
      method: "POST",
      data: { notification }
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error notifying pass")
  }
}

const notifyPasses = async ({ apiSource, apiKey, templateId, passes, notification }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/notifyPasses/${templateId}`,
      method: "POST",
      data: {
        pass_ids: passes,
        notification
      }
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error notifying passes")
  }
}

const notifyAll = async ({ apiSource, apiKey, templateId, notification }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/notifyAll/${templateId}`,
      method: "POST",
      data: { notification }
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error notifying passes")
  }
}



const getActivePassesCount = async ({ apiSource, apiKey }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getActivePassesCount`,
      method: "get"
    }

    let result = await callApi({ apiKey, apiMode: "live", options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting pass count")
  }
}

const deletePasses = async ({ apiSource, apiKey, apiMode, passes }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/deletePasses`,
      method: "delete",
      data: { passes }
    }

    let result = await callApi({ apiKey, apiMode, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error deleting passes")
  }
}


const callApi = async ({ apiKey, apiMode, options }) => {
  try {
    return await callAuthenticatedApi({
      apiSource: getApiSourceFromUrl(options.url),
      apiKey,
      apiMode,
      includeChildClientId: true,
      options
    })
  }
  catch (err) {
    console.error(err)
    throw err
  }
}

const getApiSourceFromUrl = url => {
  return url?.startsWith(apiUrls.local) ? 'local' : 'remote'
}


export {
  getActivePassesCount,
  getPass,
  getIssuedPasses,
  getPassNotifications,
  makePass,
  notifyAll,
  notifyPass,
  notifyPasses,
  patchPass,
  deletePasses,
}
